module.exports = __webpack_public_path__ + "static/media/OralMedicineRadiologyBDS2.27f91087.pdf";